import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewContainerRef,
  forwardRef,
  Input,
  ViewChild,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl, ControlContainer, FormGroupDirective } from "@angular/forms";
import { TimePickerModalService } from "./time-picker-shared/providers/time-picker-modal.service";

@Component({
  standalone: false,
  selector: "app-time-picker",
  templateUrl: "./time-picker.component.html",
  styleUrls: ["./time-picker.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TimePickerComponent),
    },
  ],
})
export class TimePickerComponent implements OnInit, ControlValueAccessor {
  /**
   * Control  of input form field component
   */
  control: AbstractControl;
  /**
   * Value  of input field component
   */
  _value = "";
  /**
   * Input  of input form field component
   */
  @Input() formControlName: string;
  /**
   * Input  of input field component
   */
  @Input() label = "input form field label";
  /**
   * Input  of input field component
   */
  // @Input() disabled = false;
  /**
   * Input  of input field component
   */
  @Input() placeholder = "";
  /**
   * Gets value
   */
  get value() {
    return this._value;
  }
  /**
   * Sets value
   */
  set value(val) {
    if (val) {
      this._value = val;
      this.onChanged(this._value);
    }
  }
  /**
   * Gets form
   */
  get form() {
      return this.controlContainer.formDirective
          ? (this.controlContainer.formDirective as FormGroupDirective).form
          : null;
  }
  /**
   * Determines whether changed on
   */
  onChanged = (val: any): void => {};
  /**
   * Determines whether touched on
   */
  onTouched = (): void => {};
  @ViewChild('body', {read: ViewContainerRef}) target: ViewContainerRef;
  /**
   * Creates an instance of time picker component.
   * @param timePickerModalService TimePickerModalService
   * @param viewContainerRef ViewContainerRef
   * @param controlContainer ControlContainer
   */
  constructor(
    private timePickerModalService: TimePickerModalService,
    private viewContainerRef: ViewContainerRef,
    public controlContainer: ControlContainer
  ) {
    this.timePickerModalService.viewContainerRef = this.viewContainerRef;
  }
  /**
   * on init
   */
  ngOnInit() {
    this.control = this.form.get(this.formControlName);
  }

  /**
   * Determines whether change event on
   * @param value any
   */
  onKeyupEvent(value: any) {
    this.writeValue(value != undefined ? value : null);
  }
  /**
   * Determines whether blur event on
   */
  onBlurEvent() {
    // if (this.control) {
    //     this.control.markAsTouched();
    // }
  }
  /**
   * Determines whether click timpe picker on
   */
  onClickTimpePicker() {
    this.timePickerModalService.show().then((res) => {
      this.writeValue(res !== undefined ?res.time : null);
    });
  }
  /**
   * Writes value
   * @param value any
   */
  writeValue(value: any): void {
    this.value = value;
  }
  /**
   * Registers on change
   * @param fn any
   */
  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }
  /**
   * Registers on touched
   * @param fn any
   */
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  // /**
  //  * Sets disabled state
  //  * @param isDisabled boolean
  //  */
  // setDisabledState?(isDisabled: boolean): void {
  //   this.disabled = isDisabled;
  // }
}
